import React from 'react';
import {
    Button,
    Modal,
    Overlay,
    Tooltip,
    DropdownButton,
    Dropdown,
    Table,
} from 'react-bootstrap';
import { useMapEverbridgeGroupModal } from './useMapEverbridgeGroupModal';
import './mapEverbridgeGroup.scss';

const MapEverbridgeGroupModal = () => {
    const {
        showModel,
        handleClose,
        handleShow,
        showTooltip,
        setShowTooltip,
        tooltipRef,
        isTokenAdded,
        handleSelectGroup,
        assignments,
        setAssignments,
        availableGroups,
        everbridgeGroupData,
        handleMapEverbridgeGroups
    } = useMapEverbridgeGroupModal();

    return (
        <>
            <span
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                ref={tooltipRef}
            >
                {!isTokenAdded && (
                    <Overlay
                        target={tooltipRef.current}
                        show={showTooltip}
                        placement='top'
                    >
                        {(props) => (
                            <Tooltip id='overlay-tooltip' {...props}>
                                Add Token to map the groups.
                            </Tooltip>
                        )}
                    </Overlay>
                )}
                <span className='everbridge-btn'>
                    <Button disabled={!isTokenAdded} onClick={handleShow}>
                        <span>Map Groups</span>
                    </Button>
                </span>
            </span>

            <Modal
                show={showModel}
                onHide={handleClose}
                className='modal-container mapsite'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Map Everbridge Groups to Fuji Groups</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mapsite-body'>
                    <Table striped bordered hover className='fixed-table'>
                        <thead>
                            <tr>
                                <th>Everbridge Group</th>
                                <th>FlashCast Group</th>
                            </tr>
                        </thead>
                        <tbody>
                            {everbridgeGroupData?.map((everbridgeGroup) => (
                                <tr key={everbridgeGroup.everbridgeGroupId}>
                                    <td>{everbridgeGroup.everbridgeGroupName}</td>
                                    <td>
                                        <DropdownButton
                                            className='dropdown-button-fixed'
                                            id={`dropdown-${everbridgeGroup.everbridgeGroupId}`}
                                            title={
                                                assignments[everbridgeGroup.everbridgeGroupId]
                                                    ? assignments[everbridgeGroup.everbridgeGroupId]
                                                    : 'Select Group'
                                            }
                                            variant={'light'}
                                        >
                                            {availableGroups?.map((group) => (
                                                <Dropdown.Item
                                                    key={group}
                                                    active={assignments[everbridgeGroup.everbridgeGroupId] === group}
                                                    onClick={() => handleSelectGroup(everbridgeGroup.everbridgeGroupId, group)}
                                                >
                                                    {group}
                                                </Dropdown.Item>
                                            ))}
                                        </DropdownButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn-cancel' onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className='btn-style' type='submit' onClick={handleMapEverbridgeGroups}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MapEverbridgeGroupModal;
